import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useActiveWeb3React from 'hooks/useActiveWeb3React';
import {
  Flex,
  Button,
  LogoutIcon,
  UserMenu as UIKitUserMenu,
  UserMenuItem,
  useModal,
  Box,
  SubMenu,
  SubMenuItem,
  ChevronDownIcon,
} from '@pancakeswap/uikit';
import useAuth from 'hooks/useAuth';
import ConnectWalletButton from 'components/ConnectWalletButton';
import { FetchStatus, useGetBnbBalance } from 'hooks/useTokenBalance';
import { useTranslation } from 'contexts/Localization';
import { createClient } from '@supabase/supabase-js';
import { ethers } from 'ethers';
import WalletModal, { WalletView, LOW_BNB_BALANCE } from './WalletModal';
import WalletModal2, { WalletView2, LOW_BNB_BALANCE2 } from './WalletModal2';
import WalletUserMenuItem from './WalletUserMenuItem';

// Supabase kapcsolat
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;
const supabase = createClient(supabaseUrl, supabaseKey);

const NETWORKS = {
  BNB: {
    chainId: '0x38', // 56 (BNB Smart Chain)
    name: 'BNB',
    url: '/',
    icon: '/images/wallet/000.png',
  },
  ETH: {
    chainId: '0x1', // 1 (Ethereum Mainnet)
    name: 'ETH',
    url: '/',
    icon: '/images/wallet/0274.png',
  },
};

const UserMenu = () => {
  const { t } = useTranslation();
  const { account, chainId } = useActiveWeb3React();
  const { logout } = useAuth();
  const { balance, fetchStatus } = useGetBnbBalance();
  const history = useHistory();
  const [onPresentWalletModal] = useModal(<WalletModal2 initialView={WalletView2.WALLET_INFO} />);
  const [onPresentHarvestModal] = useModal(<WalletModal initialView={WalletView.HARVEST} />);
  const [onPresentTransactionModal] = useModal(<WalletModal2 initialView={WalletView2.TRANSACTIONS} />);
  const hasLowBnbBalance = fetchStatus === FetchStatus.SUCCESS && balance.lte(LOW_BNB_BALANCE);

  // Felhasználói adatokat tároló state
  const [userData, setUserData] = useState({ name: '', number: '', avatar: '' });

  useEffect(() => {
    const fetchUserData = async () => {
      if (!account) return;

      try {
        const { data: userData, error } = await supabase
          .from('user_data')
          .select('name, number')
          .eq('account', account)
          .single();

        if (error) {
          console.error('Error fetching data from Supabase:', error.message);
          return;
        }

        if (userData) {
          const name = userData.name || '';
          const number = userData.number || '';

          const paddedNumber = number < 10 
            ? `0${number}` 
            : `${number}`.padStart(3, '0');

          const avatarUrl = `images/pixel/${paddedNumber}.jpg`;

          setUserData({ name, number, avatar: avatarUrl });
        }
      } catch (error) {
        console.error('Unexpected error fetching user data:', error.message);
      }
    };

    fetchUserData();
  }, [account]);

  // Hálózatváltás
  const [currentNetwork, setCurrentNetwork] = useState('BNB');

  useEffect(() => {
    if (chainId === 56) {
      setCurrentNetwork('BNB');
    } else if (chainId === 1) {
      setCurrentNetwork('ETH');
    }
  }, [chainId]);

  const onSwitchNetwork = async (network) => {
  const { chainId, name, url } = NETWORKS[network];

  try {
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId }],
    });

    history.push(url);

    // Mobilon a teljes UI frissítése biztosítja, hogy a menü is váltson
    setTimeout(() => {
      window.location.reload();
    }, 300);
  } catch (switchError) {
    console.error(`Hálózatváltás hiba: ${switchError}`);

    if (switchError.code === 4902) {
      try {
        await window.ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [
            {
              chainId,
              chainName: name,
              rpcUrls:
                network === 'BNB'
                  ? ['https://bsc-dataseed.binance.org/']
                  : ['https://mainnet.infura.io/v3/YOUR_INFURA_KEY'],
              nativeCurrency:
                network === 'BNB'
                  ? { name: 'BNB', symbol: 'BNB', decimals: 18 }
                  : { name: 'ETH', symbol: 'ETH', decimals: 18 },
            },
          ],
        });

        history.push(url);

        // Ismét teljes frissítés, hogy menü és UI biztosan váltson
        setTimeout(() => {
          window.location.reload();
        }, 300);
      } catch (addError) {
        console.error(`Hálózat hozzáadása sikertelen: ${addError}`);
      }
    }
  }
};

  const displayName = userData.name 
    ? userData.name
    : `${account?.substring(0, 2)}...${account?.substring(account.length - 4)}`;

  if (!account) {
    return <ConnectWalletButton scale="sm" />;
  } 

  return (
    <>
      {/* Lenyíló hálózatváltó menü */}
      <SubMenu
  component={
    <Button
      mr="5px"
      endIcon={<ChevronDownIcon />}
      style={{
        backgroundColor: currentNetwork === 'ETH' ? '#080f0f' : undefined, // lila háttér ETH-hoz
        color: currentNetwork === 'ETH' ? '#687de3' : undefined,              // fehér szöveg ETH-hoz
        border: `2px solid ${currentNetwork === 'ETH' ? '#687de3' : '#FFC300'}`, // ETH lila, BNB arany
      }}
      variant={currentNetwork === 'ETH' ? undefined : 'gold'} // BNB esetén arany variáns
    >
      <img
        src={NETWORKS[currentNetwork].icon}
        alt={currentNetwork}
        height="24px"
        width="24px"
      />
      <img src="/images/routers/999.png" alt="space" height="5px" width="5px" />
      {NETWORKS[currentNetwork].name}
    </Button>
  }
>

        <SubMenuItem onClick={() => onSwitchNetwork('BNB')}
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

          <img src="/images/wallet/000.png" alt="BNB" height="24px" width="24px" />
          <img src="/images/routers/999.png" alt="space" height="5px" width="5px" />
          BNB
        </SubMenuItem>

        <SubMenuItem onClick={() => onSwitchNetwork('ETH')}
                      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

          <img src="/images/wallet/0274.png" alt="ETH" height="24px" width="24px" />
          <img src="/images/routers/999.png" alt="space" height="5px" width="5px" />
          ETH
        </SubMenuItem>
      </SubMenu>
      <Box mt="10px">

      <UIKitUserMenu  
        text={displayName}
        avatarSrc={userData.avatar || 'images/pixel/200.png'}
      >
 
        <WalletUserMenuItem hasLowBnbBalance={hasLowBnbBalance} onPresentWalletModal={onPresentWalletModal} />
        <UserMenuItem as="button" onClick={onPresentTransactionModal}>
          {t('Activity')}
        </UserMenuItem>
        <UserMenuItem as="button" onClick={onPresentHarvestModal}>
          {t('Harvest')}
        </UserMenuItem>
        <UserMenuItem as="button" onClick={logout}>
          <Flex alignItems="center" justifyContent="space-between" width="100%">
            {t('Disconnect')}
            <LogoutIcon />
          </Flex>
        </UserMenuItem>
      </UIKitUserMenu>
      </Box>
    </>
  );
};

export default UserMenu;
